{
  "source": "lai-education-back/src/lib/rbac/ui-routes.ts",
  "routes": [
    {
      "path": "/getting-started",
      "access": "session",
      "screens": [],
      "reason": "Primeiros passos do próprio mentorado na marca ativa; o servidor confere titular e vínculo."
    },
    {
      "path": "/admin/diagnostics",
      "access": "capability",
      "capability": "education.diagnostics.read",
      "screens": ["education.diagnostics"]
    },
    {
      "path": "/admin/diagnostics/new",
      "access": "capability",
      "capability": "education.diagnostics.read",
      "screens": ["education.diagnostics"]
    },
    {
      "path": "/admin/diagnostics/$id",
      "access": "capability",
      "capability": "education.diagnostics.read",
      "screens": ["education.diagnostics"]
    },
    {
      "path": "/admin/diagnostics/$id/edit",
      "access": "capability",
      "capability": "education.diagnostics.read",
      "screens": ["education.diagnostics"]
    },
    {
      "path": "/admin/lesson-categories",
      "access": "capability",
      "capability": "content.lessonCategories.read",
      "screens": ["content.lessonCategories"]
    },
    {
      "path": "/business",
      "access": "session",
      "screens": [],
      "reason": "Negócios da marca ativa: principal gerencia, sócio consulta e admin gerencia na própria marca; o servidor confere o vínculo e o papel."
    },
    {
      "path": "/events",
      "access": "capability",
      "capability": "community.events.read",
      "screens": ["community.events"]
    },
    {
      "path": "/events/$id",
      "access": "capability",
      "capability": "community.events.read",
      "screens": ["community.events"]
    },
    {
      "path": "/admin/events",
      "access": "capability",
      "capability": "community.events.manage",
      "screens": ["community.events"]
    },
    {
      "path": "/admin/communications",
      "access": "capability",
      "capability": "community.communications.read",
      "screens": ["community.communications"]
    },
    {
      "path": "/communications/$id",
      "access": "capability",
      "capability": "social.notifications.read",
      "screens": ["community.notifications"]
    },
    {
      "path": "/install",
      "access": "public",
      "screens": [],
      "reason": "Instruções públicas de instalação do aplicativo; não concedem acesso a aulas ou à organização."
    },
    {
      "path": "/auth",
      "access": "public",
      "screens": [],
      "reason": "Autenticação e recuperação com token próprio; não concedem acesso à organização."
    },
    {
      "path": "/auth/google",
      "access": "public",
      "screens": [],
      "reason": "Autenticação e recuperação com token próprio; não concedem acesso à organização."
    },
    {
      "path": "/auth/google/start",
      "access": "public",
      "screens": [],
      "reason": "Autenticação e recuperação com token próprio; não concedem acesso à organização."
    },
    {
      "path": "/auth/google/handoff",
      "access": "public",
      "screens": [],
      "reason": "Autenticação e recuperação com token próprio; não concedem acesso à organização."
    },
    {
      "path": "/auth/google/complete",
      "access": "public",
      "screens": [],
      "reason": "Autenticação e recuperação com token próprio; não concedem acesso à organização."
    },
    {
      "path": "/reset-password",
      "access": "public",
      "screens": [],
      "reason": "Autenticação e recuperação com token próprio; não concedem acesso à organização."
    },
    {
      "path": "/data-lifecycle",
      "access": "public",
      "screens": [],
      "reason": "Confirmação de exclusão de dados pelo link com token enviado por e-mail; não concede acesso à organização."
    },
    {
      "path": "/privacidade",
      "access": "public",
      "screens": [],
      "reason": "Documentos legais públicos da plataforma; não concedem acesso à organização."
    },
    {
      "path": "/termos",
      "access": "public",
      "screens": [],
      "reason": "Documentos legais públicos da plataforma; não concedem acesso à organização."
    },
    {
      "path": "/f/$slug",
      "access": "public",
      "screens": [],
      "reason": "Apresentação pública de formulário ativo, resolvida pelo domínio da marca; não aceita respostas anônimas."
    },
    {
      "path": "/onboarding",
      "access": "session",
      "screens": [],
      "reason": "Diagnóstico empresarial do próprio mentorado; marca e titular são conferidos no servidor."
    },
    {
      "path": "/diagnosis",
      "access": "session",
      "screens": [],
      "reason": "Diagnóstico empresarial do próprio mentorado; marca e titular são conferidos no servidor."
    },
    {
      "path": "/forms",
      "access": "session",
      "screens": [],
      "reason": "Formulários do próprio membro; elegibilidade e tentativas são conferidas no servidor."
    },
    {
      "path": "/forms/$slug",
      "access": "session",
      "screens": [],
      "reason": "Formulários do próprio membro; elegibilidade e tentativas são conferidas no servidor."
    },
    {
      "path": "/public/p/$slug",
      "access": "public",
      "screens": [],
      "reason": "Somente página publicada na marca resolvida pelo domínio."
    },
    {
      "path": "/buy/$offerId",
      "access": "public",
      "screens": [],
      "reason": "Oferta pública e checkout com vínculo de compra próprio."
    },
    {
      "path": "/certificado/$code",
      "access": "public",
      "screens": [],
      "reason": "Verificação pública pelo código do certificado."
    },
    {
      "path": "/join/$token",
      "access": "public",
      "screens": [],
      "reason": "Convite autenticado pelo token; aceitação revalida empresa e papel."
    },
    {
      "path": "/change-password",
      "access": "session",
      "screens": [],
      "reason": "Operações da própria conta; sessão e token/concessão validados pelo servidor."
    },
    {
      "path": "/complete-profile",
      "access": "session",
      "screens": [],
      "reason": "Operações da própria conta; sessão e token/concessão validados pelo servidor."
    },
    {
      "path": "/oauth/consent",
      "access": "session",
      "screens": [],
      "reason": "Operações da própria conta; sessão e token/concessão validados pelo servidor."
    },
    {
      "path": "/no-access",
      "access": "session",
      "screens": [],
      "reason": "Operações da própria conta; sessão e token/concessão validados pelo servidor."
    },
    {
      "path": "/",
      "access": "session",
      "screens": [],
      "reason": "Contexto pessoal; cada seção protegida exige sua própria ação antes de consultar dados."
    },
    {
      "path": "/profile",
      "access": "session",
      "screens": [],
      "reason": "Contexto pessoal; cada seção protegida exige sua própria ação antes de consultar dados."
    },
    {
      "path": "/settings",
      "access": "session",
      "screens": [],
      "reason": "Contexto pessoal; cada seção protegida exige sua própria ação antes de consultar dados."
    },
    {
      "path": "/p/$slug",
      "access": "session",
      "screens": [],
      "reason": "Página publicada para leitura; editar exige permissão institucional separada."
    },
    {
      "path": "/purchases",
      "access": "session",
      "screens": [],
      "reason": "Compras e renovação do próprio usuário na organização ativa; nenhuma gestão de vendas."
    },
    {
      "path": "/badges/$badgeId/renew",
      "access": "session",
      "screens": [],
      "reason": "Compras e renovação do próprio usuário na organização ativa; nenhuma gestão de vendas."
    },
    {
      "path": "/charges/$chargeId",
      "access": "session",
      "screens": [],
      "reason": "Compras e renovação do próprio usuário na organização ativa; nenhuma gestão de vendas."
    },
    {
      "path": "/support/help",
      "access": "capability",
      "capability": "support.access",
      "screens": ["content.faq", "support.tickets"]
    },
    {
      "path": "/support/help/$category",
      "access": "capability",
      "capability": "support.access",
      "screens": ["content.faq", "support.tickets"]
    },
    {
      "path": "/faq",
      "access": "capability",
      "capability": "support.access",
      "screens": ["content.faq", "support.tickets"]
    },
    {
      "path": "/support/tickets",
      "access": "capability",
      "capability": "support.tickets.read",
      "screens": ["support.tickets"]
    },
    {
      "path": "/support/tickets/$id",
      "access": "capability",
      "capability": "support.tickets.read",
      "screens": ["support.tickets"]
    },
    {
      "path": "/journey",
      "access": "capability",
      "capability": "education.journey.read",
      "screens": ["education.progress"]
    },
    {
      "path": "/notifications",
      "access": "capability",
      "capability": "social.notifications.read",
      "screens": ["community.notifications"]
    },
    {
      "path": "/badges",
      "access": "capability",
      "capability": "education.courses.read",
      "screens": ["education.courses"]
    },
    {
      "path": "/admin/refunds",
      "access": "capability",
      "capability": "company.manage",
      "screens": ["management.refunds"]
    },
    {
      "path": "/roles",
      "access": "capability",
      "capability": "rbac.read",
      "screens": ["management.roles"]
    },
    {
      "path": "/programs",
      "access": "capability",
      "capability": "education.programs.update",
      "screens": ["education.programs"]
    },
    {
      "path": "/programs/$id/view",
      "access": "capability",
      "capability": "education.programs.update",
      "screens": ["education.programs"]
    },
    {
      "path": "/courses/$id/builder",
      "access": "capability",
      "capability": "education.courses.read",
      "screens": ["education.courses", "content.lessons"]
    },
    {
      "path": "/courses/$id/certificate",
      "access": "capability",
      "capability": "education.courses.read",
      "screens": ["education.courses"],
      "feature": "certificates"
    },
    {
      "path": "/certificates",
      "access": "capability",
      "capability": "education.courses.read",
      "screens": ["education.courses"],
      "feature": "certificates"
    },
    {
      "path": "/courses",
      "access": "capability",
      "capability": "content.lessons.read",
      "screens": ["content.lessons"]
    },
    {
      "path": "/courses/$id",
      "access": "capability",
      "capability": "content.lessons.read",
      "screens": ["content.lessons"]
    },
    {
      "path": "/courses/library",
      "access": "capability",
      "capability": "content.lessons.read",
      "screens": ["content.lessons"]
    },
    {
      "path": "/courses/$id/view",
      "access": "capability",
      "capability": "content.lessons.read",
      "screens": ["content.lessons"]
    },
    {
      "path": "/courses/$id/lessons/$lessonId",
      "access": "capability",
      "capability": "content.lessons.read",
      "screens": ["content.lessons"]
    },
    {
      "path": "/spaces",
      "access": "capability",
      "capability": "community.spaces.read",
      "screens": ["community.spaces"],
      "feature": "community.spaces"
    },
    {
      "path": "/spaces/$id",
      "access": "capability",
      "capability": "community.spaces.read",
      "screens": ["community.spaces"],
      "feature": "community.spaces"
    },
    {
      "path": "/feed",
      "access": "capability",
      "capability": "social.feed.read",
      "screens": [
        "community.posts",
        "community.comments",
        "community.reactions",
        "operation.adDelivery"
      ],
      "feature": "social.feed"
    },
    {
      "path": "/posts/$id",
      "access": "capability",
      "capability": "social.feed.read",
      "screens": [
        "community.posts",
        "community.comments",
        "community.reactions",
        "operation.adDelivery"
      ],
      "feature": "social.feed"
    },
    {
      "path": "/saved-posts",
      "access": "capability",
      "capability": "social.feed.read",
      "screens": [
        "community.posts",
        "community.comments",
        "community.reactions",
        "operation.adDelivery"
      ],
      "feature": "social.feed"
    },
    {
      "path": "/mentions",
      "access": "capability",
      "capability": "social.notifications.read",
      "screens": ["community.notifications"],
      "feature": "social.mentions"
    },
    {
      "path": "/users/$id",
      "access": "capability",
      "capability": "social.graph.read",
      "screens": ["community.people"]
    },
    {
      "path": "/messages",
      "access": "capability",
      "capability": "social.dm.read",
      "screens": ["community.messages"],
      "feature": "social.messages"
    },
    {
      "path": "/showcase",
      "access": "capability",
      "capability": "showcase.read",
      "screens": ["education.programs"],
      "feature": "showcase"
    },
    {
      "path": "/showcase/$id",
      "access": "capability",
      "capability": "showcase.read",
      "screens": ["education.programs"],
      "feature": "showcase"
    },
    {
      "path": "/ranking",
      "access": "capability",
      "capability": "gamification.read",
      "screens": ["operation.gamification"],
      "feature": "gamification"
    },
    {
      "path": "/admin/gamification-badges",
      "access": "capability",
      "capability": "gamification.badges.access",
      "screens": ["operation.gamification"],
      "feature": "gamification"
    },
    {
      "path": "/admin",
      "access": "capability",
      "capability": "admin.dashboard.read",
      "screens": ["operation.analytics"],
      "feature": "analytics"
    },
    {
      "path": "/admin/user-scores",
      "access": "capability",
      "capability": "admin.dashboard.read",
      "screens": ["operation.analytics"],
      "feature": "analytics"
    },
    {
      "path": "/wallet",
      "access": "capability",
      "capability": "wallet.read",
      "screens": ["operation.wallet"],
      "feature": "gamification"
    },
    {
      "path": "/admin/features",
      "access": "capability",
      "capability": "platform.features.read",
      "screens": ["management.features"]
    },
    {
      "path": "/company",
      "access": "capability",
      "capability": "company.read",
      "screens": ["company.details", "company.brands", "company.admins", "education.offers"]
    },
    {
      "path": "/admin/branding",
      "access": "capability",
      "capability": "branding.access",
      "screens": ["management.branding", "content.showcases"]
    },
    {
      "path": "/admin/showcases",
      "access": "capability",
      "capability": "content.showcases.read",
      "screens": ["content.showcases"]
    },
    {
      "path": "/admin/showcases/$id",
      "access": "capability",
      "capability": "content.showcases.read",
      "screens": ["content.showcases"]
    },
    {
      "path": "/admin/branding/vitrine/$id",
      "access": "capability",
      "capability": "content.showcases.read",
      "screens": ["content.showcases"]
    },
    {
      "path": "/admin/branding/vitrine/$id/preview",
      "access": "capability",
      "capability": "content.showcases.read",
      "screens": ["content.showcases"]
    },
    {
      "path": "/admin/tags",
      "access": "capability",
      "capability": "management.tags.read",
      "screens": ["management.tags", "community.tags"]
    },
    {
      "path": "/admin/sales",
      "access": "capability",
      "capability": "education.offers.read",
      "screens": ["education.offers"]
    },
    {
      "path": "/admin/access-badges",
      "access": "capability",
      "capability": "education.badges.read",
      "screens": ["education.badges"]
    },
    {
      "path": "/admin/access-badges/$id",
      "access": "capability",
      "capability": "education.badges.read",
      "screens": ["education.badges"]
    },
    {
      "path": "/admin/certificates",
      "access": "capability",
      "capability": "education.certificates.read",
      "screens": ["education.certificates"],
      "feature": "certificates"
    },
    {
      "path": "/admin/certificates/models/$id",
      "access": "capability",
      "capability": "education.certificates.read",
      "screens": ["education.certificates"],
      "feature": "certificates"
    },
    {
      "path": "/admin/ads",
      "access": "capability",
      "capability": "operation.ads.read",
      "screens": ["operation.ads"]
    },
    {
      "path": "/admin/moderation",
      "access": "capability",
      "capability": "moderation.read",
      "screens": ["management.moderation"]
    },
    {
      "path": "/admin/audit",
      "access": "capability",
      "capability": "audit.read",
      "screens": ["management.audit"]
    },
    {
      "path": "/admin/lesson-comments",
      "access": "capability",
      "capability": "management.lessonComments.read",
      "screens": ["management.lessonComments"]
    },
    {
      "path": "/admin/users",
      "access": "capability",
      "capability": "admin.users.read",
      "screens": ["management.users"]
    },
    {
      "path": "/admin/domains",
      "access": "capability",
      "capability": "moderation.domains.read",
      "screens": ["management.domains"]
    },
    {
      "path": "/admin/insights",
      "access": "capability",
      "capability": "insights.read",
      "screens": ["operation.insights"],
      "feature": "analytics"
    },
    {
      "path": "/admin/integrations",
      "access": "capability",
      "capability": "integrations.access",
      "screens": ["management.integrations", "management.mcp"]
    },
    {
      "path": "/admin/integrations/settings",
      "access": "capability",
      "capability": "integrations.access",
      "screens": ["management.integrations", "management.mcp"]
    },
    {
      "path": "/admin/integrations/direct",
      "access": "capability",
      "capability": "integrations.read",
      "screens": ["management.integrations"]
    },
    {
      "path": "/admin/integrations/logs",
      "access": "capability",
      "capability": "integrations.read",
      "screens": ["management.integrations"]
    },
    {
      "path": "/admin/institutional",
      "access": "capability",
      "capability": "cms.access",
      "screens": ["content.pages", "content.templates", "content.mobileMenu"]
    },
    {
      "path": "/cohorts",
      "access": "capability",
      "capability": "education.cohorts.update",
      "screens": ["education.cohorts"]
    },
    {
      "path": "/mentees",
      "access": "capability",
      "capability": "education.enrollments.read",
      "screens": ["education.enrollments"]
    },
    {
      "path": "/analytics",
      "access": "capability",
      "capability": "analytics.read",
      "screens": ["operation.analytics"],
      "feature": "analytics"
    },
    {
      "path": "/outcomes",
      "access": "capability",
      "capability": "outcome.contracts.read",
      "screens": ["learning.contracts"],
      "feature": "outcome_engine"
    },
    {
      "path": "/commitments",
      "access": "capability",
      "capability": "accountability.commitments.read",
      "screens": ["learning.commitments"],
      "feature": "outcome_engine"
    },
    {
      "path": "/analytics/diagnosis/$userId",
      "access": "capability",
      "capability": "diagnosis.analytics.read",
      "screens": ["operation.diagnosisAnalytics"],
      "feature": "diagnosis_analytics"
    }
  ],
  "screens": [
    "support.tickets",
    "education.programs",
    "education.courses",
    "education.cohorts",
    "education.enrollments",
    "education.progress",
    "education.badges",
    "education.offers",
    "education.diagnostics",
    "education.certificates",
    "content.lessons",
    "content.lessonCategories",
    "content.lessonComments",
    "content.showcases",
    "content.pages",
    "content.templates",
    "content.mobileMenu",
    "content.faq",
    "learning.contracts",
    "learning.commitments",
    "learning.interventions",
    "learning.applicables",
    "learning.twins",
    "learning.helena",
    "community.spaces",
    "community.posts",
    "community.comments",
    "community.reactions",
    "community.people",
    "community.tags",
    "community.messages",
    "community.notifications",
    "community.communications",
    "community.events",
    "operation.gamification",
    "operation.wallet",
    "operation.adDelivery",
    "operation.ads",
    "operation.analytics",
    "operation.insights",
    "operation.diagnosisAnalytics",
    "operation.mentoringAnalytics",
    "management.lessonComments",
    "management.users",
    "management.moderation",
    "management.domains",
    "management.audit",
    "management.branding",
    "management.tags",
    "management.roles",
    "management.features",
    "management.integrations",
    "management.mcp",
    "management.connections",
    "management.refunds",
    "company.details",
    "company.brands",
    "company.admins"
  ],
  "capabilities": [
    "accountability.commitments.act",
    "accountability.commitments.read",
    "admin.dashboard.read",
    "admin.users.manage",
    "admin.users.read",
    "ads.manage",
    "ads.read",
    "analytics.read",
    "audit.read",
    "audit.review",
    "branding.access",
    "branding.manage",
    "branding.read",
    "cms.access",
    "community.comments.create",
    "community.comments.read",
    "community.comments.remove",
    "community.communications.read",
    "community.communications.send",
    "community.events.manage",
    "community.events.read",
    "community.events.rsvp",
    "community.messages.markRead",
    "community.messages.send",
    "community.notifications.markAllRead",
    "community.notifications.markRead",
    "community.people.follow",
    "community.people.unfollow",
    "community.posts.create",
    "community.posts.pin",
    "community.posts.remove",
    "community.posts.save",
    "community.posts.unpin",
    "community.posts.unsave",
    "community.posts.update",
    "community.posts.usePrivilegedCategory",
    "community.reactions.add",
    "community.reactions.read",
    "community.reactions.remove",
    "community.spaces.addMember",
    "community.spaces.create",
    "community.spaces.createGroup",
    "community.spaces.join",
    "community.spaces.leave",
    "community.spaces.manage",
    "community.spaces.read",
    "community.spaces.removeMember",
    "community.spaces.renewMember",
    "community.spaces.update",
    "company.manage",
    "company.read",
    "content.faq.create",
    "content.faq.read",
    "content.faq.remove",
    "content.faq.update",
    "content.lessonCategories.create",
    "content.lessonCategories.read",
    "content.lessonCategories.remove",
    "content.lessonCategories.update",
    "content.lessonComments.create",
    "content.lessonComments.read",
    "content.lessons.askHelena",
    "content.lessons.create",
    "content.lessons.downloads",
    "content.lessons.importProgress",
    "content.lessons.manage",
    "content.lessons.materialCreate",
    "content.lessons.materialRemove",
    "content.lessons.publish",
    "content.lessons.rate",
    "content.lessons.read",
    "content.lessons.recordWatch",
    "content.lessons.unpublish",
    "content.lessons.update",
    "content.lessons.upload",
    "content.mobileMenu.read",
    "content.mobileMenu.update",
    "content.pages.create",
    "content.pages.publish",
    "content.pages.read",
    "content.pages.unpublish",
    "content.pages.update",
    "content.progress.import",
    "content.showcases.create",
    "content.showcases.default",
    "content.showcases.duplicate",
    "content.showcases.publish",
    "content.showcases.read",
    "content.showcases.remove",
    "content.showcases.unpublish",
    "content.showcases.update",
    "content.templates.create",
    "content.templates.read",
    "content.templates.update",
    "diagnosis.analytics.read",
    "education.access-badges.manage",
    "education.badges.archive",
    "education.badges.bulk",
    "education.badges.contents",
    "education.badges.create",
    "education.badges.grant",
    "education.badges.read",
    "education.badges.remove",
    "education.badges.revoke",
    "education.badges.unarchive",
    "education.badges.update",
    "education.certificates.assign",
    "education.certificates.create",
    "education.certificates.default",
    "education.certificates.import",
    "education.certificates.issue",
    "education.certificates.issueEligible",
    "education.certificates.manage",
    "education.certificates.read",
    "education.certificates.remove",
    "education.certificates.update",
    "education.cohorts.cancel",
    "education.cohorts.complete",
    "education.cohorts.create",
    "education.cohorts.open",
    "education.cohorts.read",
    "education.cohorts.update",
    "education.courses.archive",
    "education.courses.create",
    "education.courses.publish",
    "education.courses.read",
    "education.courses.update",
    "education.diagnostics.create",
    "education.diagnostics.read",
    "education.diagnostics.remove",
    "education.diagnostics.update",
    "education.enrollments.assignCustomRole",
    "education.enrollments.cancel",
    "education.enrollments.complete",
    "education.enrollments.create",
    "education.enrollments.import",
    "education.enrollments.invite",
    "education.enrollments.pause",
    "education.enrollments.provision",
    "education.enrollments.read",
    "education.enrollments.resume",
    "education.enrollments.revokeInvite",
    "education.journey.read",
    "education.offers.create",
    "education.offers.manage",
    "education.offers.publish",
    "education.offers.purchaseRuleRemove",
    "education.offers.purchaseRuleSet",
    "education.offers.read",
    "education.offers.subscriptionRuleRemove",
    "education.offers.subscriptionRuleSet",
    "education.offers.unpublish",
    "education.offers.update",
    "education.programs.archive",
    "education.programs.create",
    "education.programs.publish",
    "education.programs.read",
    "education.programs.update",
    "education.progress.read",
    "gamification.badges.access",
    "gamification.heartbeat",
    "gamification.manage",
    "gamification.read",
    "helena.advice.read",
    "helena.advice.request",
    "insights.manage",
    "insights.read",
    "integrations.access",
    "integrations.manage",
    "integrations.read",
    "intervention.manage",
    "intervention.read",
    "learning.applicables.propose",
    "learning.applicables.publish",
    "learning.applicables.read",
    "learning.applicables.reject",
    "learning.applicables.submit",
    "learning.applicables.write",
    "learning.commitments.accept",
    "learning.commitments.propose",
    "learning.commitments.review",
    "learning.commitments.submit",
    "learning.contracts.accept",
    "learning.contracts.observe",
    "learning.contracts.propose",
    "learning.helena.approve",
    "learning.helena.propose",
    "learning.helena.reject",
    "learning.interventions.approve",
    "learning.interventions.cancel",
    "learning.interventions.execute",
    "learning.interventions.open",
    "learning.interventions.resolve",
    "learning.twins.claim",
    "learning.twins.create",
    "learning.twins.update",
    "management.audit.review",
    "management.branding.updateAppearance",
    "management.branding.updateSettings",
    "management.connections.create",
    "management.connections.remove",
    "management.connections.test",
    "management.domains.add",
    "management.domains.remove",
    "management.integrations.createApiKey",
    "management.integrations.createAutomation",
    "management.integrations.createWebhook",
    "management.integrations.retryDelivery",
    "management.integrations.revokeApiKey",
    "management.integrations.sendTest",
    "management.integrations.verifyApiKey",
    "management.lessonComments.answer",
    "management.lessonComments.markAllAnswered",
    "management.lessonComments.read",
    "management.lessonComments.remove",
    "management.mcp.create",
    "management.mcp.revoke",
    "management.moderation.removeComment",
    "management.moderation.removePost",
    "management.tags.create",
    "management.tags.read",
    "management.tags.remove",
    "management.tags.update",
    "management.users.assignRole",
    "management.users.delegate",
    "management.users.export",
    "management.users.remove",
    "management.users.resetPassword",
    "management.users.restore",
    "management.users.suspend",
    "mcp.connections.manage",
    "mcp.connections.read",
    "mcp.manage",
    "mcp.read",
    "mentoring.analytics.read",
    "moderation.domains.read",
    "moderation.manage",
    "moderation.read",
    "operation.ads.activate",
    "operation.ads.create",
    "operation.ads.deactivate",
    "operation.ads.read",
    "operation.ads.remove",
    "operation.ads.update",
    "operation.diagnosisAnalytics.exclude",
    "operation.diagnosisAnalytics.viewAll",
    "operation.gamification.awardBadge",
    "operation.gamification.heartbeat",
    "operation.gamification.saveBadge",
    "operation.insights.upsert",
    "operation.wallet.debit",
    "operation.wallet.grant",
    "operation.wallet.summary",
    "outcome.contracts.manage",
    "outcome.contracts.read",
    "platform.features.manage",
    "platform.features.read",
    "platform.features.removeOverride",
    "platform.features.setOverride",
    "platform.features.update",
    "rbac.create",
    "rbac.read",
    "rbac.remove",
    "rbac.update",
    "showcase.read",
    "social.comments.write",
    "social.dm.read",
    "social.dm.write",
    "social.feed.read",
    "social.graph.read",
    "social.graph.write",
    "social.notifications.mark_read",
    "social.notifications.read",
    "social.posts.moderate",
    "social.posts.write",
    "social.reactions.write",
    "support.access",
    "support.tickets.create",
    "support.tickets.read",
    "support.tickets.reply",
    "tags.manage",
    "tags.read",
    "twin.manage",
    "twin.read",
    "wallet.manage",
    "wallet.read"
  ],
  "features": [
    "analytics",
    "certificates",
    "community.spaces",
    "diagnosis_analytics",
    "gamification",
    "helena",
    "lead_twin",
    "mentoring_analytics",
    "outcome_engine",
    "showcase",
    "social.feed",
    "social.mentions",
    "social.messages"
  ]
}
